import type { Route } from '~/core/router'

import { Slot } from '~/core/router'
import { NotificationToasts } from '~/entities/notification-toasts'
import * as pinLockFeature from '~/features/pin-lock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import { keys } from '~/shared/jail'
import { NoContentBlock } from '~/shared/ui/components/NoContentBlock'
import { NavBar } from '~/widgets/NavBar'
import { PartnerProgramGoPopup } from '~/widgets/PartnerProgram/PartnerProgramGoPopup'
import { ExternalPaymentOpen } from '~/widgets/Payment'
import {
  AnnouncementPopup,
  InfoPopup,
  MessagePortal,
  MotnStreamingOptionsPopup,
  ProfilesRemovePopup,
  VoiceSearchPopup,
} from '~/widgets/Popups'
import { SignInToWatchPopup } from '~/widgets/Popups/SignInToWatchPopup'
import { ContentFooter } from './ContentFooter'
import * as event from './event'
import * as live from './live'
import * as motn from './motn'
import * as movie from './movie'
import * as partner from './partner'
import * as series from './series'

export const route: Route = {
  keys: [keys.app, keys.guest],

  component: [
    NavBar,
    Slot,
    ExternalPaymentOpen,
    SignInToWatchPopup,
    pinLockFeature.PinLockPopup,
    NoContentBlock,
    ContentFooter,
    InfoPopup,
    MotnStreamingOptionsPopup,
    VoiceSearchPopup,
    NotificationToasts,
    PartnerProgramGoPopup,
    ProfilesRemovePopup,
    AnnouncementPopup,
    AccountSettingsModal,
    MessagePortal,
  ],

  children: [
    {
      path: '/event',
      load: event.route,
      // load: () => import('./event').then((m) => m.route),
    },
    {
      path: '/live',
      load: live.route,
      // load: () => import('./live').then((m) => m.route),
    },
    {
      path: '/movie',
      load: movie.route,
      // load: () => import('./movie').then((m) => m.route),
    },
    {
      path: '/partner',
      load: partner.route,
      // load: () => import('./partner').then((m) => m.route),
    },
    {
      path: '/series',
      load: series.route,
      // load: () => import('./series').then((m) => m.route),
    },
    {
      path: '/motn',
      load: motn.route,
    },
  ],
}
